import { FC, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const Timer1: FC = () => {
  const [min, setMin] = useState(5);
  const [sec, setSec] = useState(0);
  const [isExpired, setIsExpired] = useState(false);
  const time = useRef<any>(299);
  const timerId = useRef<any>(null);
  const { t } = useTranslation();

  useEffect(() => {
    timerId.current = setInterval(() => {
      setMin(parseInt(String(time.current / 60)));
      setSec(time.current % 60);
      time.current -= 1;
    }, 1000);

    return () => clearInterval(timerId.current);
  }, []);

  useEffect(() => {
    if (time.current <= 0) {
      clearInterval(timerId.current);
      setIsExpired(true);
    }
  }, [sec]);

  return (
    <span style={{ fontSize: '8px', color: 'red' }}>
      {
        isExpired
          ? t('student.student.column130')
          : `${t('student.student.column131')} ${min}:${sec < 10 ? `0${sec}` : sec}`
      }      
    </span>
  );
};

export default Timer1;